import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const GET_ITEM_QUERY = print(gql`
  query Tag($id: Int!) {
    Tag(id: $id) {
      id
      name
      createdAt
      updatedAt
    }
  }
`);

export interface GetItemGql {
  Tag: {
    id: number;
    name: string;
    createdAt: Date;
    updatedAt: Date;
  };
}
